import React from "react";
import { View, Text, StyleSheet, Image, TouchableOpacity } from "react-native";
// import Icon from 'react-native-ionicons';
import { Ionicons as Icon } from "@expo/vector-icons";
import { AuthContext } from "../../contexts/auth/Store";
import { CartContext } from "../../contexts/cart/Store";
import Config from "../../constants/Config";
import {
  GetProductStockCount,
  GetLowerUpperUnitText,
} from "../../constants/Utils";
import { AnalyticsService } from "../../constants/Analytics";
import FontStyles from "../../constants/FontStyle";
import Colors from "../../constants/Colors";
import { ProductContext } from "../../contexts/product/Store";
import AddEditCartItemModal from "../modals/AddEditCartItemModal";
import http from "../../utils/http";
import { formatCurrency } from "../../utils/money";
import StyledIcon from "../StyledIcon";
import IconText from "../common/IconText";
import Divider from "../common/Divider";

const analytics = new AnalyticsService();

export default function CartItem({ item }) {
  const auth = React.useContext(AuthContext);
  const token = auth.getUserData.userToken;
  const buyer = auth.getUserData.buyerData;
  const [cart_state, cart_dispatch, cart_fetch] = React.useContext(CartContext);
  const { product_state } = React.useContext(ProductContext);

  const [isSubmitting, setSubmitting] = React.useState(false);
  const [isEditing, setEditing] = React.useState(false);
  const [inStock, setStock] = React.useState(null);

  const openModal = () => {
    setEditing(true);
  };
  const hideModal = () => {
    setEditing(false);
  };

  const removeItem = (id) => {
    setSubmitting(true);
    let form = new FormData();
    form.append("_id", id);
    http
      .post("order_group_item/remove", form, token)
      .then((res) => {
        setSubmitting(false);
        if (res.code === 200) {
          cart_fetch()
            .then((res) => {})
            .catch((err) => {});
          cart_dispatch({ type: "REMOVE_ORDER_GROUP_ITEM", payload: id });
          analytics.logEvent("Removed From Cart", buyer, {
            product_id: item._id,
            product_name: item.product.name,
          });
        }
      })
      .catch((err) => {
        setSubmitting(false);
        console.log(err);
      });
  };

  React.useState(() => {
    //
    if (product_state) {
      let stock = GetProductStockCount(item.product);
      if (stock !== 0) {
        setStock(stock);
      }
    }
  }, [item]);

  return (
    <View key={item._id}>
      {isEditing && (
        <AddEditCartItemModal
          hideModal={hideModal}
          modalState={isEditing}
          product={item.product}
          navigateAway={true}
        />
      )}

      <View style={[styles.container, { opacity: isSubmitting ? 0.4 : 1 }]}>
        <View style={styles.imageContainer}>
          <Image
            source={{
              uri: `${Config.uploadUrl}${item?.product?.upload?.path}`,
            }}
            style={styles.image}
          />
        </View>
        <View style={styles.contentContainer}>
          <Text style={styles.titleText} numberOfLines={2}>
            {item.product.name}
          </Text>
          <TouchableOpacity
            style={{ flexDirection: "row", alignItems: "center" }}
            onPress={openModal}
          >
            <Text style={styles.qtyText}>
              {GetLowerUpperUnitText(item.product, item.quantity)}
            </Text>
            <Text>{` `}</Text>
            <IconText
              icon="square-edit-outline"
              color={Colors.greyColor}
              size={14}
              text="Change"
              iconLibrary="MaterialCommunityIcons"
              textStyle={styles.qtyText}
            />
          </TouchableOpacity>
          <View style={styles.detailContainer}>
            <View style={styles.priceDetailContainer}>
              {inStock ? (
                <>
                  <Text style={styles.priceText}>
                    {formatCurrency(item.amount)}
                  </Text>
                </>
              ) : (
                <Text style={[styles.priceText, { ...FontStyles.gray }]}>
                  Out of Stock
                </Text>
              )}
            </View>
            <TouchableOpacity
              style={styles.removeBtn}
              disabled={isSubmitting}
              onPress={() => removeItem(item._id)}
            >
              <IconText
                icon="trash-bin"
                color={Colors.dangerText}
                size={14}
                text="Remove"
                textStyle={{...FontStyles.size13 }}
                iconLibrary="Ionicons"
              />
            </TouchableOpacity>
          </View>
        </View>
      </View>
      <Divider margin={8} />
    </View>
  );
}

const styles = StyleSheet.create({
  container: {
    flex: 1,
    flexDirection: "row",
  },
  contentContainer: {
    flex: 1,
    paddingTop: 14,
    paddingLeft: 10,
    paddingBottom: 10,
    paddingRight: 16,
  },
  imageContainer: {
    padding: 6,
  },
  image: {
    width: 82,
    height: undefined,
    minHeight: 92,
    aspectRatio: 82 / 92,
  },
  titleText: {
    ...FontStyles.dark,
    ...FontStyles.size13,
    ...FontStyles.lh18,
    ...FontStyles.normal,
  },
  subTitleText: {
    ...FontStyles.normal,
    ...FontStyles.gray,
    ...FontStyles.size14,
    ...FontStyles.lh18,
  },
  hr: {
    height: 1,
    width: "100%",
    backgroundColor: "rgba(0,0,0,0.05)",
  },
  detailContainer: {
    flex: 1,
    flexDirection: "row",
    justifyContent: "space-between",
  },
  priceDetailContainer: {
    flexDirection: "row",
    alignSelf: "flex-end",
    flexShrink: 1,
    alignItems: "center",
    flexWrap: "wrap",
  },
  priceText: {
    ...FontStyles.size15,
    ...FontStyles.lh18,
    ...FontStyles.bold,
    paddingRight: 8,
  },
  qtyText: {
    ...FontStyles.normal,
    ...FontStyles.gray,
  },
  removeBtn: {
    paddingLeft: 20,
    alignSelf: "flex-end",
  },
});
